'use strict';

/*global app*/
/*global isEmpty*/
/*global BasicProcess*/

function TransferNoteProcess(containerId, settings) {
  BasicProcess.call(this, containerId, settings);

  this.init();
}

TransferNoteProcess.prototype = $.extend({}, BasicProcess.prototype, {
  constructor: 'TransferNoteProcess',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  onAfterInit: function onAfterInit() {
    var _this = this;

    _this.printCustomerLabels();

    return _this;
  },

  onAfterSaveProcessItemResult: function onAfterSaveProcessItemResult($item, result) {
    var _this = this;

    var serialNumber = _this.getItemValue($item, 'SerialNumber');
    var printSerialNumber = _this.getFormBoolValue('PrintCustomerSNFromProcessing');
    var webDocumentItemRID = _this.getItemValue($item, 'WebDocumentItemRID');
    var amount = _this.getItemFloatValue($item, 'Amount');

    if (!isEmpty(serialNumber) && printSerialNumber) {
      //vytiskneme zakaznicky stitek
      app.printer.printCustomerLabel(webDocumentItemRID, amount);
    }

    _this.checkZeroStockLevel($item, result);

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
